import Component from './OrgSwitcher.component';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';
import { selectCustomer } from './OrgSwitcher.commands';

const mapStateToProps = state => {
    const currentCustomerId = fromState.Auth.customer.getId(state);
    const customerIds = fromState.Auth.user.customers.getResults(state);
    const localeCode = fromState.Locale.getLocaleCode(state);
    const customers = fromState.DB.customer
        .getEntitiesForIds(state, customerIds)
        .slice()
        .sort((a, b) =>
            (a?.name || '').localeCompare(b?.name || '', localeCode || undefined, {
                sensitivity: 'base',
            })
        );
    return {
        currentCustomerId,
        customerIds,
        customers,
        customerName: (fromState.DB.customer.getEntityById(state, currentCustomerId) || {}).name,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        selectCustomer: customer => dispatch(selectCustomer(customer)),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { customers } = stateProps;
    return {
        ...ownProps,
        ...stateProps,
        // Look up by id so the sorted display order can't misalign the selection.
        onChangeCustomer: customerId =>
            dispatchProps.selectCustomer(customers.find(c => c.customerId === customerId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component);
